
import React from 'react';
import { Business } from '@/data/types/businessTypes';
import { LogoLayout } from '../useLogoUpload';

interface LandingPagePreviewProps {
  business: Business;
  logoPreview: string | null;
  logoLayout: LogoLayout;
}

export const LandingPagePreview: React.FC<LandingPagePreviewProps> = ({
  business,
  logoPreview,
  logoLayout
}) => {
  // Generate logo display classes based on the selected layout
  const getLogoClasses = () => {
    const baseClasses = "flex-shrink-0 flex items-center";
    
    switch (logoLayout) {
      case 'landscape':
        return `${baseClasses} h-10 max-w-32 mr-4`;
      case 'portrait':
        return `${baseClasses} h-12 max-w-10 mr-4`;
      case 'square':
      default:
        return `${baseClasses} h-12 w-12 mr-4`;
    }
  };

  return (
    <div className="w-full max-w-md">
      {/* Header with logo */}
      <div className="bg-white p-4 shadow-sm rounded-t-md flex items-center">
        <div className={getLogoClasses()}>
          {logoPreview ? (
            <img src={logoPreview} alt="Business logo" className="h-full object-contain" />
          ) : (
            <div className="w-12 h-12 flex items-center justify-center text-xs text-gray-400 bg-gray-100">No Logo</div>
          )}
        </div>
        <div>
          <div className="font-bold text-sm">{business.title || 'Business Name'}</div>
          <div className="text-xs text-gray-500">{business.industry || 'Business Industry'}</div>
        </div>
      </div>
      
      {/* Main content mockup */}
      <div className="bg-white p-4 shadow-sm rounded-b-md space-y-2">
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        <div className="h-4 bg-gray-200 rounded w-full"></div>
        <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        <div className="h-10 bg-gray-200 rounded w-full mt-4"></div>
      </div>
    </div>
  );
};
